import React, { useState } from 'react';
import {
	Drawer,
	Box,
	Typography,
	List,
	ListItem,
	ListItemText,
	IconButton,
	Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import { css, StyleSheet } from 'aphrodite';
import DashboardHome from '../dashboard';
import PatientRecords from './patientrecords';
// import Doctors from './pages/Doctors';
import Purchases from './hospital-inventory';
import TreatmentHistoryPage from './treatmentrecords';
import AppointmentsCalendar from './appointments-calender';
// import Settings from './pages/Settings';
import { useSelector } from 'react-redux';

const menuItems = [
	{ key: 'dashboard', label: 'Dashboard', icon: <BusinessIcon /> },
	{ key: 'patients', label: 'Patients', icon: <PeopleIcon /> },
	{ key: 'staff', label: 'Staff', icon: <MedicalServicesIcon /> },
	{ key: 'purchases', label: 'Purchases', icon: <LocalPharmacyIcon /> },
	{
		key: 'treatmentrecords',
		label: 'Treatment Records',
		icon: <MedicalServicesIcon />,
	},
	{ key: 'appointments', label: 'Appointments', icon: <CalendarMonthIcon /> },
	{ key: 'settings', label: 'Settings', icon: <SettingsIcon /> },
];

const Sidebar = () => {
	const [isOpen, setIsOpen] = useState(true);
	const [activePage, setActivePage] = useState('dashboard');

	const hospitalName = useSelector(
		(state) => state.hospitalAuth?.user?.hospital_name,
	);

	return (
		<Box display="flex">
			<Drawer
				variant="permanent"
				sx={{
					width: isOpen ? 240 : 70,
					flexShrink: 0,
					'& .MuiDrawer-paper': {
						width: isOpen ? 240 : 70,
						backgroundColor: '#ffffff',
						transition: 'width 0.3s ease-in-out',
						padding: '10px 0',
						overflowX: 'hidden',
					},
				}}
			>
				{/* Sidebar Header with Toggle Button */}
				<div className={css(styles.menuIconContainer)}>
					<IconButton
						onClick={() => setIsOpen(!isOpen)}
						className={css(styles.menuButton)}
						aria-label="Toggle Sidebar"
					>
						<MenuIcon />
					</IconButton>
					<span className={css(styles.hospitalName)}>
						{hospitalName || 'Hospital'}
					</span>
				</div>

				{/* Navigation List */}
				<List className={css(styles.list)}>
					{menuItems.map(({ key, label, icon }) => (
						<Tooltip key={key} title={!isOpen ? label : ''} placement="right">
							<ListItem
								button
								onClick={() => setActivePage(key)}
								className={css(
									styles.listItem,
									activePage === key && styles.activeItem,
								)}
							>
								{icon}
								{isOpen && (
									<ListItemText primary={label} className={css(styles.text)} />
								)}
							</ListItem>
						</Tooltip>
					))}
				</List>
			</Drawer>
		</Box>
	);
};

const styles = StyleSheet.create({
	menuButton: {
		color: '#000',
	},
	menuIconContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '10px',
		borderBottom: '1px solid #ddd',
	},
	list: {
		padding: 0,
	},
	listItem: {
		padding: '15px 20px',
		color: '#333',
		transition: 'background 0.3s, color 0.3s',
		display: 'flex',
		alignItems: 'center',
		gap: 15,
		borderRadius: '6px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f1f1f1',
		},
	},
	activeItem: {
		backgroundColor: '#e3f2fd',
		color: '#1565c0',
		fontWeight: 'bold',
	},
	text: {
		fontSize: '16px',
	},
	hospitalName: {
		fontSize: '18px',
		marginLeft: '10px',
		fontWeight: 'bold',
		color: '#333',
	},
});

export default Sidebar;
